/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

import {useMemo} from 'react'
import {useLocation} from 'react-router-dom'

// Utils
import {buildUrlSet} from '@salesforce/retail-react-app/app/utils/url'
import {DEFAULT_LIMIT_VALUES} from '../constants'

/*
 * Generate a memoized list of page size urls. Changing sort will reset
 * the products count to default to simplify things.
 */
export const useSortUrls = ({options = []}) => {
    const location = useLocation()

    return useMemo(
        () =>
            buildUrlSet(
                `${location.pathname}${location.search}`,
                'sort',
                options.map(({id}) => id),
                {
                    products: DEFAULT_LIMIT_VALUES[0],
                    limit: undefined,
                    offset: undefined
                }
            ),
        [location.pathname, location.search, options]
    )
}
